/**
 * Fires the given callback when the DOM is loaded.
 * This function also takes into account if the DOMContentLoaded event was already fired.
 * 
 * @param callback  The callback to trigger.
 */
export function DOMReady(callback: () => any) {
  document.readyState === 'interactive' || document.readyState === 'complete' ? callback() : document.addEventListener('DOMContentLoaded', callback);
}
